import styled, { keyframes } from 'styled-components';

import { fadeOut } from '../../styles/shared.style';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Popover = styled.section<{$render: boolean}>`
  position: relative;
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;

  &:hover {
    cursor: ${({ $render }) => $render ? 'pointer' : 'default'};
  }
`;

export const PopoverContent = styled.section<{ $show: boolean; $top: number; $left: number }>`
  position: absolute;
  width: 340px;
  left: ${({ $left }) => `${$left - 25}px`};
  top: ${({ $top }) => `${$top + 55}px`};
  background-color: ${({ theme }) => theme.colors.surface.high};
  border-radius: 12px;
  padding: 16px;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  animation: ${({ $show }) => ($show ? fadeIn : fadeOut)} 1s ease-out;
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: visibility 1s linear, opacity 1s linear;
  z-index: 999999999;

  & span {
    font-family: 'Elza', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 14.52px;
    text-align: left;
  }

  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 2rem;
    transform: translateX(-50%);
    border-width: 11px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 2rem;
    transform: translateX(-50%);
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent ${({ theme }) => theme.colors.surface.high} transparent;
  }
`;
